// Phase 1 is English-only. Kept as thin passthroughs so existing imports keep working
// without a separate translation system.
export function LanguageProvider({ children }) { return children; }
export function useLang() { return { lang: "en", setLang: () => {} }; }
export function useT() { return (s) => s; }
